<ion-header class="lang-picker-header">
  <ion-toolbar>
    <ion-title class="lang-picker-title">
      {{ 'LANGUAGE.PICKER_TITLE' | translate }}
    </ion-title>
  </ion-toolbar>

  <ion-toolbar class="lang-search-toolbar">
    <ion-searchbar
      [(ngModel)]="searchQuery"
      [placeholder]="'LANGUAGE.SEARCH_PLACEHOLDER' | translate"
      animated
      class="lang-searchbar">
    </ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content class="lang-picker-content">
  <ion-list lines="full" class="lang-list">
    <ion-item
      *ngFor="let lang of filtered"
      button
      tappable
      (click)="select(lang)"
      [class.lang-item-selected]="lang.code === selectedCode"
      class="lang-item">
      <ion-label class="lang-label">
        <h3 class="lang-native">{{ lang.nativeLabel }}</h3>
        <p class="lang-english">{{ lang.label }}</p>
      </ion-label>
      <ion-icon
        *ngIf="lang.code === selectedCode"
        slot="end"
        name="checkmark-circle"
        color="primary"
        class="lang-check">
      </ion-icon>
    </ion-item>

    <div *ngIf="filtered.length === 0" class="lang-empty">
      <ion-icon name="search-outline"></ion-icon>
        <p>{{ 'LANGUAGE.NO_MATCH' | translate:{query: searchQuery} }}</p>
    </div>
  </ion-list>
</ion-content>
